import ApiService from '@/services/Base/ApiService';

/* eslint-disable */
const getDefaultState = () => {
  return {
    kitRegion: null,
    selectedRegion: null,

    regionDatas: [],
  }
}

const state = getDefaultState()

const getters = {
  getRegionDatas(state) {
    return state.regionDatas;
  },

  getSelectedRegion() {
    return state.selectedRegion;
  },
}

const mutations = {
  setKitRegion(state, data) {
    state.kitRegion = data;
    state.selectedRegion = data;
  },
  setSelectRegion(state, data) {
    state.selectedRegion = data;
  },
  setRegionDatas(state, data) {
    state.regionDatas = data;
  },
}

const actions = {
  async fetchKitRegion(context, regionGuid) {
    try {
      const response = await ApiService.get(`Region/${regionGuid}`);
      if (response.statusCode === 200) {
        context.commit('setKitRegion', response.result)
      } else {
        console.error('Error fetching data:', response.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  },
  async fetchRegionDatas(context) {
    try {
      const response = await ApiService.get('SharedRegion');
      if (response.statusCode === 200) {
        context.commit('setRegionDatas', response.result)
      } else {
        console.error('Error fetching data:', response.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
